/// <reference path="../app.ts" />
namespace Cfnc {
    export class PhoneNumber {
        static filterId: string = "phoneNumber";

        static filter() {
            return function (phone: string) {
                var test = phone.search(/[a-zA-Z]/g);
                if (test != -1) {
                    return phone;
                }
                else {
                    phone = phone.replace(/\D/g, '');
                    return "(" + phone.substr(0, 3) + ") " + phone.substr(3, 3) + "-" + phone.substr(6, 4);
                }
            }
        }
    }
    angular.module("app").filter(PhoneNumber.filterId, [PhoneNumber.filter]);
}